import { createStore } from "vuex";
import { login } from "../API/API";
import httpClient from "../API/HttpClient";
import router from "../route";

export default createStore({
  state: {
    token: localStorage.getItem("token") || "",
    seq: localStorage.getItem("seq") || "",
  },
  mutations: {
    SET_TOKEN(state, data) {
      state.token = data.token;
      localStorage.setItem("token", state.token);
      state.seq = data.seq;
      localStorage.setItem("seq", state.seq);
    },
    REMOVE_TOKEN(state) {
      state.token = "";
      state.seq = "";
      localStorage.removeItem("token");
      localStorage.clear();
    },
  },
  actions: {
    login({ commit }, { UserName, Password }) {
      return new Promise((resolve, reject) => {
        login(UserName, Password)
          .then((resp) => {
            httpClient.defaults.headers.common["Authorization"] =
              "Bearer " + resp.data.token;
            commit("SET_TOKEN", resp.data);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    logout({ commit }) {
      commit("REMOVE_TOKEN");
      router.push("/login");
    },
  },
  getters: {
    isLoggedIn: (state) => state.token !== "",
    token: (state) => "Bearer " + state.token,
    seq: (state) => state.seq,
  },
});
